import ProductList from "@/Controller/ProductList";
window.app = new ProductList;